import React, { useState, useEffect } from "react";
import { Table, Alert, ConfigProvider } from "antd";
import { getAPI } from "../../../config/api/apiConfig";

import { DeleteOutlined, EditOutlined, LoadingOutlined} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";

const columns = [
  {
    title: "Device Type",
    dataIndex: "deviceType",
    key: "deviceType",
  },
  {
    title: "Device Name",
    dataIndex: "deviceName",
    key: "deviceName",
  },
  {
    title: "Device Model",
    dataIndex: "deviceModel",
    key: "deviceModel",
  },
  {
    title: "Organisation Name",
    dataIndex: "organisationName",
    key: "organisationName",
  },
  // {
  //   title: "Scanner Name",
  //   dataIndex: "biometricScanner",
  //   key: "biometricScanner",
  // },
  {
    title: "Action",
    dataIndex: "",
    key: "x",
    render: () => (
      <a>
        <EditOutlined />
      </a>
    ),
  },
  {
    title: "",
    dataIndex: "",
    key: "x",
    render: () => (
      <a>
        <DeleteOutlined />
      </a>
    ),
  },
];


const ListTreatedDevice = () => {
  const [deviceData, setDeviceData] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const role = useSelector((state) => state.authenticate.role);

  let status;
  if (role === "Nibss_Super_Cert01") {
    status = "approved";
  } else if (role === "Nibss_Admin_Ticket") {
    status = "treated";
  } else {
    status = "pending";
  }

  const dispatch = useDispatch();
  const getDevices = async () => {
    const devices = await getAPI(`/get-device-status/${status}`);
    const { data } = devices.data;
    setDeviceData(data);
    console.log(data);
  };


  const columnData = [];
  deviceData.map((device) => {

    const data = {
      key: device.id,
      deviceType: device.deviceType,
      deviceName: device.deviceName,
      deviceModel: device.deviceModel,
      organisationName: device.organisationName,
      // biometricScanner: device.biometricScanner,
      description: `This device with Id ${device.id}, has been treated`,
    };
    
    //dispatch(setListDevice(data));
    columnData.push(data);
  });


  const handleExpand = (expanded, record) => {
    if (expanded) {
      setExpandedRowKeys([record.key]);
    } else {
      setExpandedRowKeys([]);
    }
  };

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
      }}
      spin
    />
  );

  useEffect(() => {
    getDevices();
  }, []);

  return deviceData.length !== 0 ? (
    <Table
      columns={columns}
      expandable={{
        expandedRowRender: (record) => (
          <p
            style={{
              margin: 0,
            }}
          >
            {record.description}
          </p>
        ),
        rowExpandable: (record) => record.name !== "Not Expandable",
        expandedRowKeys,
        onExpand: handleExpand,
      }}
      dataSource={columnData}
    />
  ): ( <Alert
    message="No Device "
    description="No pending device to treat"
    className="alert"
    showIcon
  />);
};

export default ListTreatedDevice;
